/******/ (() => { // webpackBootstrap
/* eslint-disable */
rimg.shopify.init('[data-rimg="lazy"]', {
  round: 1
});
const sections = new ShopifySectionsManager();
sections.register('age-gate', section => new AgeGate.PageAgeGate(section));
const ageGatePage = document.getElementById('age-gate-page');
if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}
document.addEventListener('DOMContentLoaded', function () {
  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;
  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();
  window.header.init();
  window.mobileSearch.init();
  window.siteOverlay.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.predictiveSearch.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();
  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const {
    pathname
  } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            if ($('.main-nav__wrapper.sticky_nav').length > 0) window.header.unload();
            window.header.init();
          }
        }
        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');
          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }
            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? '4:3' : '16:9';
  }
  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');
    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Collection sorting

  const sortByEl = document.querySelector('[data-sort-by]');
  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const {
        target
      } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }
  $('body').on('change', '#tag_filter', () => {
    $('[data-option-filter] input').prop('checked', false);
    window.quickFilter.init();
  });
  $('body').on('change', '#blog_filter', function () {
    const url = $(this).val();
    window.location = url;
  });
  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: $('.content').offset().top
    }, 500);
  });
  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });
  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });
  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });
  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });
  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }
  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });
  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });
  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }
  if (window.PXUTheme.theme_settings.enable_back_to_top_button) {
    window.back_to_top_button.init();
  }
  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({
      scrollTop: $('#new-comment').offset().top - 140
    }, 'slow');
  }
  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, {
      offset: '70%'
    });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, {
      offset: '70%'
    });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, {
      offset: '70%'
    });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, {
      offset: '70%'
    });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2
  });
  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a');
  window.utils.initializeTabs();
  window.accordion.init();
  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });
  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }
  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }
  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);
    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }
  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('[data-product-list]');
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('[data-product-list]');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      }
    });
  }
  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
id: cartItem.key,
},
      success(data) {
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }

          $('.warning--quantity').remove();

          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      },
    });
  }

  function refreshCartID () {
    const cartItem = document.querySelectorAll('.cart__item');

    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');

      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  function refreshCart(cart) {
(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined' && (cart = window.BOLD.common.cartDoctor.fix(cart)));

    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = "";
    let cartDiscountsHTML = "";
    let cartActionHTML = "";
    let cartSavingsHTML = "";
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;

    $cartForm.data('total-discount', cart.total_discount);
    let customItemCount = 0;
    const itemList = cart.items
    for (const item of itemList) {
      if (item.properties) {
        if (!item.properties.hasOwnProperty('For')) {
          if (parseInt(item.quantity)) customItemCount+= parseInt(item.quantity)
        }
      } else {
          if (parseInt(item.quantity)) customItemCount+= parseInt(item.quantity)
      }
    }

    $cartBtn.text(value.replace(/[0-9]+/, customItemCount));

    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');

      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;

      $.each(cart.items, (index, item) => {
        var props = "";
        const lineID = index + 1;

        let customID = ''
        let customProduct = false
        let customItem = false
        let customization = {
          front: {
            state: false,
            name: "Front"
          },
          right: {
            state: false,
            name: "Right"
          },
          back: {
            state: false,
            name: "Back"
          },
          left: {
            state: false,
            name: "Left"
          }
        }

        for (var propName in item.properties) {
            if (propName == 'Custom Product ID' && item.properties[propName]) {
            customID = item.properties[propName]
            customProduct = true
            }else if (propName == 'Custom ID' != 0 && item.properties[propName]) {
              customID = item.properties[propName]
              customItem = true
            }
        }
     
        if (customProduct) {
          for (var k in item.properties) {
            if (k.includes('Front') && item.properties[k]) customization["front"].state = true
            if (k.includes('Right') && item.properties[k]) customization["right"].state = true
            if (k.includes('Back') && item.properties[k]) customization["back"].state = true
            if (k.includes('Left') && item.properties[k]) customization["left"].state = true
          }
          props += '<div class="custom-properties-container">'
          for (const key in customization) {
            if (customization[key].state) {
              props += `<h6>${customization[key].name}</h6>`
              for (var k in item.properties) {
                if (k.indexOf('_') != 0 && item.properties[k]) {
                  if (k.includes(customization[key].name)) {
                    if (k.includes('Cost')) {
                      props += `<p class="no-break"><strong>${k.split(' - ')[1]} - ${item.properties[k]}</strong><br>`
                    } else {
                      if (k.includes('upload') || k.includes('Upload')) {
                        props += '<span>File Upload : <a href="' + item.properties[k] + '">Uploaded File</a></span>';
                       } else {
                        props += "<span>" + k.split(' - ')[1] + ": " + item.properties[k] + "</span><br>"
                       }
                    }
                  }
                }
              }
            }
          }
          props += '</div><div class="custom-item__footer"><button data-show-custom>View all customizations</button></div>'
        } else {
          for (var k in item.properties) {
            if (k.indexOf('_') != 0 && item.properties[k]) {
           if (k.includes('upload') || k.includes('Upload')) {
            props += '<span>File Upload : <a href="' + item.properties[k] + '">Uploaded File</a></span>';
           } else {
            props += "<div>" + k + ": " + item.properties[k] + "</div>"
           }
           }
           }
        }
        const itemDiscounts = item.discounts;
        let discountMessage = '';

        for (let i = 0; i < itemDiscounts.length; i++) {
          const { title } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
       

        if (customID) {
          if (customItem) {
            cartItemsHTML += `<li class="mini-cart__item hidden-custom" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}" data-custom-id="${customID}">`
          + `<a href="${item.url}">`;
          } else {
            cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}" data-custom-id="${customID}">`
          + `<a href="${item.url}">`;
          }
            
        }else {
          cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">`
          + `<a href="${item.url}">`;
        }
          if (item.image) {
            cartItemsHTML += `${'<div class="cart_image">'
                + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
              + '</div></a>';
          }

          if (customProduct) {
            cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}"><h4>${item.title.split(' - ')[0]} - ${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</h4></a></div>`;
          } else {
            cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}"><h4>${item.title}</h4></a></div>`;

          }
  
          if (customProduct) {
            cartItemsHTML += `<div class="mini-cart__item-options"><span>${item.title.substring(item.title.indexOf(" - ") + 3)}</span><br><br>`;
          } else {
            cartItemsHTML += `<div><strong>${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</strong>`;
          }
  
          if (item.selling_plan_allocation) {
            cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
          }

          cartItemsHTML += `<a href="${item.url}" class="cart__item-edit" data-edit="${customID}">Edit Customization</a>`

  
          if(props) {cartItemsHTML += '<div class="line-item">' + props + '</div>';}
          cartItemsHTML += '</div><div class="mini-cart__item-price">';

          if (customProduct) {
            cartItemsHTML += `<p></p><p class="custom_total has-margin-bottom"><strong>Total: </strong><span class="money" style="font-weight: 400">`;
          } else {
            cartItemsHTML += `<p></p><p class="price_total has-margin-bottom"><strong>Total: </strong><span class="money" style="font-weight: 400">`;
          }
          let totalCost;
          for (var k in item.properties) {
            if (k == 'Total' && item.properties[k]) totalCost = item.properties[k]
          }
          cartItemsHTML += `$ ${totalCost}.00</span></p>`;

          // $.ajax({
          //   dataType: 'json',
          //   async: false,
          //   cache: false,
          //   url: `/products/${item.handle}.js`,
          //   success(data) {
          //     let productData = data;
          //     // If item has more than one variant, need to make sure we are pulling data from the correct variant
          //     if (productData.variants) {
          //       const itemVariants = productData.variants;
          //       if (itemVariants.length > 1) {
          //         for (let v = 0; v < itemVariants.length; v++) {
          //           if (itemVariants[v].id === item.id) {
          //             productData = itemVariants[v];
          //           }
          //         }
          //       }
          //     }
  
          //     // If compare at price exists then item is on sale
          //     if (productData.compare_at_price) {
          //       if (productData.compare_at_price > productData.price) {
          //         productHasSale = true;
          //         productCompareAtPrice = productData.compare_at_price;
          //         productFinalPrice = productData.price;
          //       }
          //     } else {
          //       // Check required for non-sale items
          //       productHasSale = false;
          //     }
          //   },
          // });
  
          // if (productHasSale === true) {
          //   // puts the slash through the old item price
          //   const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
          //   cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
  
          //   // Total savings
          //   saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
          //   totalSaving = saving + totalSaving;
          // } else if (item.price > item.final_price) {
          //   // puts the slash through the old item price
          //   const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
          //   cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
          // } else {
          //   const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
          //   if (item.price > 0) {
          //     cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
          //   } else {
          //     cartItemsHTML += `<span>${window.Shopify.translation.cart_free_text}</span></strong>`;
          //   }
          // }
  
          cartItemsHTML += '</div>';
  
          // Unit price
  
          if (item.unit_price_measurement && item.price > 0) {
            let unitPriceMeasurementReferenceValue = '';
  
            if (item.unit_price_measurement.reference_value !== 1) {
              unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
            }
  
            cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
          }
  
          if (item.price > item.final_price) {
            cartItemsHTML += discountMessage;
          }

          if (customProduct) {
            cartItemsHTML += '<div class="product-quantity-box">';
            cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
            cartItemsHTML += `<input type="number" min="0" class="quantity custom" name="updates[]" id="updates_${item.id}"  data-id="${item.key}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
            cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
            cartItemsHTML += '</div></div></div>';
            cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn"  data-id="${item.key}" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
          } else if(!customItem)  {
            cartItemsHTML += '<div class="product-quantity-box">';
            cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
            cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}"  data-id="${item.key}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
            cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
            cartItemsHTML += '</div></div></div>';
            cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn"  data-id="${item.key}" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
          } else {
            cartItemsHTML += '<div class="product-quantity-box product-quantity-box--hidden">';
            cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity is-disabled hidden" data-func="minus"><span class="icon-minus"></span></span>';
            cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}"  data-id="${item.key}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
            cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity is-disabled hidden" data-func="plus"><span class="icon-plus"></span></span>';
            cartItemsHTML += '</div></div></div>';
            cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn"  data-id="${item.key}" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon" hidden aria-hidden="true"></span></a>`;
          }
      });

      const cartDiscounts = cart.cart_level_discount_applications;

      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const { title } = cartDiscounts[i];

        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }

      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${Shopify.translation.cart_subtotal_text}</span>`;
      totalSaving += cart.total_discount;
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
            + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }

    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_savings').html(cartSavingsHTML);

    customizerCart()


    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
    (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded')));
}

function customizerCart() {
  const showCustom = document.querySelectorAll('[data-show-custom]')
  const propContainer = document.querySelectorAll('.custom-properties-container')
  const editBtns = document.querySelectorAll('[data-edit]')
  showCustom.forEach((elem, index) => {
    elem.addEventListener('click', (e) => {
    e.preventDefault()
    if (propContainer[index].classList.contains('active')) {
      propContainer[index].classList.remove('active')
      elem.textContent = 'View All Customizations'
    } else {
      propContainer[index].classList.add('active')
      elem.textContent = 'Close Customizations'
    }
  })
  })
   // Save custom ID of clicked item link
   editBtns.forEach((elem, index) => {
    let itemCustomId = elem.dataset.edit
    if (localStorage.getItem(`customdata-${elem.dataset.edit}`) === null) {
      elem.classList.add('hidden')
    }
    elem.addEventListener('click', () => {
      localStorage.setItem("clickedItem", itemCustomId);
    })
  })

  const qtyInput = document.querySelectorAll('.quantity.custom')
    qtyInput.forEach((elem, index) => updatePrices(elem, index))

  function updatePrices (input, index) {
      let priceElems = input.parentElement.parentElement.parentElement.querySelectorAll('.custom-properties-container p > strong')
      let totalPrice = input.parentElement.parentElement.querySelector('.money')
      let feeString = ''
      let feeData = 0
      priceElems.forEach(elem => {
        if (elem.textContent.includes('+')) {
          feeString = elem.textContent.substring(elem.textContent.indexOf('+') + 1)
        }
        let priceData = parseInt(elem.textContent.substring(elem.textContent.indexOf('$') + 1))
        priceData *= qtyInput[index].value;
        elem.textContent = elem.textContent.substr(0, elem.textContent.indexOf('$'));
        feeString ? elem.textContent += `$${priceData} + ${feeString}` :  elem.textContent += `$${priceData}`
        if (feeString) {
          feeData += parseInt(feeString.match(/(\d+)/));
        }
        feeString = ''
      })
      totalPriceData = parseInt(totalPrice.textContent.substring(totalPrice.textContent.indexOf('$ ') + 1))
      if (feeData) totalPriceData -= feeData
      totalPriceData *= qtyInput[index].value
      if (feeData) totalPriceData += feeData
      totalPrice.textContent = `$ ${totalPriceData}`
    }
}

customizerCart()
  /* =================
  New Funtion
  --------------------
  */

  function updateCartItemQuantityWithLineItems(cartItems, location) {
    // const cartForm = cartItems[0].parentCartForm
    let formData = {
      'updates': {}
    }

    for (i = 0; i < cartItems.length; i++) {
      const item = cartItems[i]
      // Validate that item.key exists before using it
      if (item.key && item.key !== 'undefined') {
        formData['updates'][item.key] = parseInt(item.quantity)
      } else {
        console.warn('Cart item missing valid key:', item)
      }
    }

    let info = fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(response => response.json()).then(data => {
      return data
    }).then((data) => {
      if (location === 'cart-template') {
        window.location.reload()
      } else {
        refreshCart(data)
      }
    }).then(() => {
    }).catch((error) => {
      console.error('Error:', error);
    });
  }

  $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      customID: $(this).parents('[data-cart-item]').data('custom-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
      key: $(this).data('id'),
    };


    const $lineItem = $(this).parents('[data-cart-item]').siblings('[data-custom-id]')
    let cartItemsArray = [cartItem]

    if ($lineItem.length > 0) {
      const len = $lineItem.length
      if (len == 1) {
        const lineItem = {
          lineID: $lineItem.data('line-id'),
          variantID: $lineItem.data('variant-id'),
          customID: $lineItem.data('custom-id'),
          quantity: cartItem.quantity,
          parentCartForm: $lineItem.parents('[data-cart-form]'),
          totalDiscount: $lineItem.parents('[data-cart-form]').data('total-discount'),
          $element: $lineItem,
          key: $lineItem.find('[data-id]').data('id')
        }
        if (lineItem.$element.data('custom-id') == cartItem.customID) {
          cartItemsArray.push(lineItem)
        }
        if (lineItem.quantity == 0) {
          window.localStorage.removeItem(`customdata-${cartItem.customID}`)
        }  else {
          if(cartItem.customID) {
            let customData = JSON.parse(window.localStorage.getItem(`customdata-${cartItem.customID}`))
            customData[Object.keys(customData)[Object.keys(customData).length - 1]] = {name: "quantity", value: lineItem.quantity }
            window.localStorage.setItem(`customdata-${cartItem.customID}`,  JSON.stringify(customData));
          }
        }
      } else {
        $lineItem.each(function (i, item) {
          const lineItem = {
            lineID: $(item).data('line-id'),
            variantID: $(item).data('variant-id'),
            customID: $(item).data('custom-id'),
            quantity: $(this).val(),
            parentCartForm: $(item).parents('[data-cart-form]'),
            totalDiscount: $(item).parents('[data-cart-form]').data('total-discount'),
            $element: $(item),
            key: $(item).find('[data-id]').data('id')
          }
          if (!lineItem.$element.data('custom')) {
            lineItem.quantity = cartItem.quantity
          }
          if (lineItem.$element.data('custom-id') == cartItem.customID) {
            if (lineItem.customID == cartItem.customID) {
              // For logo registration fees qty should always be 1
              if (lineItem.quantity != 0) {
                if (lineItem.variantID === 39874957279313 ||
                  lineItem.variantID === 40066009432145 ||
                  lineItem.variantID === 39919976644689 ||
                  lineItem.variantID === 39919976677457) {
                lineItem.quantity = 1
               }
              }
              cartItemsArray.push(lineItem)
            }
          }
          if (lineItem.quantity == 0) {
            window.localStorage.removeItem(`customdata-${cartItem.customID}`)
          }  else {
            if (cartItem.customID) {
              let customData = JSON.parse(window.localStorage.getItem(`customdata-${cartItem.customID}`))
              customData[Object.keys(customData)[Object.keys(customData).length - 1]] =  {name: "quantity", value: lineItem.quantity }
              window.localStorage.setItem(`customdata-${cartItem.customID}`,  JSON.stringify(customData));
            }
          }
        })
      }
      updateCartItemQuantityWithLineItems(cartItemsArray, $(this).data('cart-quantity-input'))
    } else {
      updateCartItemQuantity(cartItem)
    }
  });

  $('body').on('click', '[data-remove-item]', '*:not(span)', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      customID: $(this).parents('[data-cart-item]').data('custom-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
      key: $(this).data('id'),
    };

    const $lineItem = $(this).parents('[data-cart-item]').siblings('[data-custom-id]')
    let cartItemsArray = [cartItem]

    if ($lineItem.length > 0) {
      const len = $lineItem.length
      if (len == 1) {
        const lineItem = {
          lineID: $lineItem.data('line-id'),
          variantID: $lineItem.data('variant-id'),
          customID: $lineItem.data('custom-id'),
          quantity: 0,
          parentCartForm: $lineItem.parents('[data-cart-form]'),
          totalDiscount: $lineItem.parents('[data-cart-form]').data('total-discount'),
          $element: $lineItem,
          key: $lineItem.find('[data-id]').data('id')
        }
        if (lineItem.$element.data('custom-id') == cartItem.customID) {
          lineItem.$element.addClass('animated fadeOutLeft');
          cartItemsArray.push(lineItem)
        }
        cartItem.$element.addClass('animated fadeOutLeft');
        window.localStorage.removeItem(`customdata-${cartItem.customID}`)
      } else {
        $lineItem.each(function (i, item) {
          const lineItem = {
            lineID: $(item).data('line-id'),
            variantID: $(item).data('variant-id'),
            customID: $(item).data('custom-id'),
            quantity: 0,
            parentCartForm: $(item).parents('[data-cart-form]'),
            totalDiscount: $(item).parents('[data-cart-form]').data('total-discount'),
            $element: $(item),
            key: $(item).find('[data-id]').data('id')
          }
          if (lineItem.$element.data('custom-id') == cartItem.customID) {
            lineItem.$element.addClass('animated fadeOutLeft');
            cartItemsArray.push(lineItem)
          }
          cartItem.$element.addClass('animated fadeOutLeft');
        })
      }
      window.localStorage.removeItem(`customdata-${cartItem.customID}`)
      updateCartItemQuantityWithLineItems(cartItemsArray , $(this).data('remove-item'))
    } else {
      cartItem.$element.addClass('animated fadeOutLeft');
      updateCartItemQuantity(cartItem);

      if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
        cartItem.$element.find('input').val('0');
        cartItem.parentCartForm.submit();
      }

      if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
        cartItem.$element.find('input').val('0');
      }
    }
  });


  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
/* BOLD PO Fix
        data: $addToCartForm.serialize(),
        */
data: window.FormData ? new FormData($addToCartForm[0]) : $addToCartForm.serialize(),
contentType: false,
processData: false,
beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }
                }
              }, 500);
            },
          });
        },
        error(XMLHttpRequest) {
          let response = eval(`(${XMLHttpRequest.responseText})`);
          response = response.description;
          $('.warning').remove();

          const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
    });
  }

  window.productPage.productSwatches();
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }
  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
    }
  });
};
window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
/******/ })()
;